import { Card, Col } from "react-bootstrap";
import  { Fragment } from 'react';
import motimaticLogo from "src/assets/images/brand-logos/motimatic.png";
import { Paths } from "src/paths";
import { navigate } from "src/navigate";
import { navigationStore } from "@store/navigationStore";

export default function PasswordChanged() {
    const backToLogin = () => {
        navigationStore.postLoginRedirect = Paths.CONTENT_CATALOG;
        navigate(Paths.LOGIN);
    }
    return (
        <Fragment>
        <div className="container-lg">
            <div className="row justify-content-center authentication authentication-basic align-items-center h-100">
                <Col xxl={4} xl={5} lg={5} md={6} sm={8} className="col-12">
                    <div className="my-0 d-flex justify-content-center">
                        <div className="my-4 d-flex justify-content-center no-background w-50 mx-auto">
                            <img src={motimaticLogo} alt="logo" className="img-fluid" />
                        </div>
                    </div>
                    <Card className="custom-card">
                        <div className="card-body p-4">
                            <p className="h5 fw-semibold mb-2 text-center">Password Changed Successfully</p>
                            <p className="text-center">Your password has been changed successfully. You can now login with your new password.</p>
                            <span onClick={backToLogin} role="button" className="text-primary text-center d-flex justify-content-center">Back to login</span>
                        </div>
                    </Card>
                </Col>
            </div>
        </div>
    </Fragment>
    )
}